import React from 'react';
import {TicketsForm} from '../../components/Form/TicketsForm';
import {useSendTicketForm} from '../../hooks/tickets';
import {TicketGroupT} from '../../external_usage';
import {createTicketsMap} from '../../helpers/guests';

export const SendTicketForm = ({group}: {group: TicketGroupT}) => {
  const {values, error, handleChange, changeQuantity} = useSendTicketForm();
  const ticketsMap = createTicketsMap(group);
  return (
    <TicketsForm
      values={values}
      error={error}
      handleChange={handleChange}
      changeQuantity={changeQuantity}
      tickets={ticketsMap}
    />
  );
};
